import BaseRepository from '@/api/repositories/BaseRepository';

export default class PDFDamagecasesRepository extends BaseRepository {
	get endpoint() {
		return 'api/pdf/damagecases';
	}

	getSavedDocument(uuid) {
		return this.get(':uuid/file', { uuid }, { responseType: 'arraybuffer' });
	}
}
